import React, { useEffect, useState } from 'react';
import { executionOperationsService } from '../../services/executionOperationsService';

export const OperationsQueuesPage: React.FC = () => {
  const [queues, setQueues] = useState<Record<string, unknown>[]>([]);
  const [configs, setConfigs] = useState<Record<string, unknown>[]>([]);
  const [inspect, setInspect] = useState<Record<string, unknown> | null>(null);
  const [selected, setSelected] = useState<string>('celery');

  const reload = async () => {
    const [q, c] = await Promise.all([
      executionOperationsService.getQueues(),
      executionOperationsService.getQueueConfigurations(),
    ]);
    setQueues((q.data as Record<string, unknown>[]) || []);
    setConfigs((c.data as Record<string, unknown>[]) || []);
  };

  useEffect(() => {
    void reload();
  }, []);

  const onInspect = async (physical: string) => {
    setSelected(physical);
    const res = await executionOperationsService.inspectQueue(physical);
    setInspect(res.data || null);
  };

  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
        Queue pause/drain/resume records configuration only until <code>EXECUTION_QUEUE_CONTROL_ENABLED</code> (Phase 4).
        No routing or worker changes in Phase 3.
      </div>
      <div className="grid gap-4 lg:grid-cols-2">
        <div className="rounded-xl border border-enterprise-200 bg-white p-4">
          <h2 className="mb-3 font-semibold">Live queues</h2>
          <ul className="divide-y text-sm">
            {queues.map((q) => (
              <li key={String(q.physical_queue)} className="flex items-center justify-between py-2">
                <button
                  type="button"
                  className="text-left font-medium text-enterprise-accent hover:underline"
                  onClick={() => onInspect(String(q.physical_queue))}
                >
                  {String(q.display_name || q.physical_queue)}
                </button>
                <span className="font-mono">depth {String(q.depth ?? 0)}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-xl border border-enterprise-200 bg-white p-4">
          <h2 className="mb-3 font-semibold">Inspector — {selected}</h2>
          {inspect ? (
            <pre className="max-h-96 overflow-auto rounded bg-enterprise-50 p-3 text-xs">{JSON.stringify(inspect, null, 2)}</pre>
          ) : (
            <p className="text-sm text-enterprise-500">Select a queue to inspect.</p>
          )}
        </div>
      </div>
      <div className="rounded-xl border border-enterprise-200 bg-white p-4">
        <h2 className="mb-3 font-semibold">Queue routing configuration</h2>
        <pre className="max-h-80 overflow-auto rounded bg-enterprise-50 p-3 text-xs">{JSON.stringify(configs, null, 2)}</pre>
      </div>
    </div>
  );
};
